"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBodyLock = void 0;

var tslib_1 = require("tslib");

var body_scroll_lock_1 = require("body-scroll-lock");

var react_1 = require("react");
/**
 * useBodyLock hook allows you to lock users from interacting with the UI.
 * @param targetRef An active element of the UI that is unaffected by the scroll lock.
 * @param initialState Initial state of the body scroll lock. `false` by default.
 */


var useBodyLock = function useBodyLock(targetRef, initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _a = tslib_1.__read((0, react_1.useState)(initialState), 2),
      isEnabled = _a[0],
      _setEnabled = _a[1];

  var setEnabled = (0, react_1.useCallback)(function (setTo) {
    var _a, _b; // 'body-scroll-lock' library requires an active element in the view.


    if (targetRef) {
      // added a workaround to (v4.0.0-beta-0) issue where `position: fixed`
      // is added to <body> on iOS, which causes the document to scroll to the top
      // https://github.com/willmcpo/body-scroll-lock/issues/237
      var storedScrollY = window.scrollY;

      if (setTo) {
        _setEnabled(setTo);

        (0, body_scroll_lock_1.disableBodyScroll)(targetRef, {
          allowTouchMove: function allowTouchMove(el) {
            // 'while' can't be replaced with 'if' in this case
            // otherwise scroll stays broken on iOS devices
            while (el && el !== document.body) {
              if (el.getAttribute('data-body-scroll-lock-ignore') !== null) {
                return true;
              }

              if (el.parentElement) {
                el = el.parentElement;
              }
            }

            return false;
          }
        });
        document.body.style.setProperty('top', "".concat(window.scrollY * -1, "px"));
      } else {
        _setEnabled(setTo);

        (0, body_scroll_lock_1.enableBodyScroll)(targetRef);
        document.body.style.setProperty('top', '');
        (_b = (_a = document.body).scrollTo) === null || _b === void 0 ? void 0 : _b.call(_a, 0, storedScrollY);
      }
    }
  }, [targetRef]);
  (0, react_1.useEffect)(function () {
    setEnabled(initialState);
    return function () {
      return setEnabled(false);
    };
  }, [targetRef, setEnabled, initialState]);
  return [isEnabled, setEnabled];
};

exports.useBodyLock = useBodyLock;